import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { BadgeColorsEnum } from 'src/app/shared/interfaces/BadgeColorsEnum';
import { InventoryLocationStatusEnum } from 'src/app/shared/interfaces/InventoryLocationStatusEnum';
import { IInventoryLocation } from 'src/app/shared/interfaces/inventory-location.interface';
import { PinService } from 'src/app/shared/services/pin.service';
import { GetAllLocations } from 'src/app/shared/states/inventory/inventory.actions';
import { InventoryState } from 'src/app/shared/states/inventory/inventory.state';
import { ToggleInventoryLocations } from 'src/app/shared/states/pharmacy/pharmacy.actions';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import { SaveInventoryLocation } from 'src/app/shared/states/settings/settings.actions';

@UntilDestroy()
@Component({
  selector: 'app-inventory-locations-setting',
  templateUrl: './inventory-locations-setting.component.html',
  styleUrls: ['./inventory-locations-setting.component.scss', '../../settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InventoryLocationsSettingComponent implements OnInit {

  BadgeColorsEnum = BadgeColorsEnum;
  InventoryLocationStatusEnum = InventoryLocationStatusEnum;

  currentWITab = InventoryLocationStatusEnum.Active;
  displayAddEditLocationDialog$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  activeInventoryLocationList: IInventoryLocation[] = [];
  inactiveInventoryLocationList: IInventoryLocation[] = [];

  toggleInventoryLocationsChannel = "inventoryLocations";
  saveInventoryLocationsChannel = "saveInventoryLocations";

  updateLocationData: IInventoryLocation;
  saveInventoryLocationData: {name: string, description?: string};


  @Select(PharmacyState.loading) loading$: Observable<boolean>;
  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;
  @Select(InventoryState.locations) inventoryLocations$: Observable<IInventoryLocation[]>;

  /**
   *
   */
  constructor(private store: Store, private pinService: PinService, private cd: ChangeDetectorRef) {
  }
  ngOnInit(): void {
    this.inventoryLocations$
    .pipe(untilDestroyed(this))
    .subscribe(locations => {
      this.activeInventoryLocationList = locations?.filter(x => x?.status === InventoryLocationStatusEnum.Active);
      this.inactiveInventoryLocationList = locations?.filter(x => x?.status === InventoryLocationStatusEnum.Inactive);
      this.cd.detectChanges();
    });

    this.pinService.validatePin$
    .pipe(untilDestroyed(this))
    .subscribe(res => {
      if (res?.success && res.dialogId === this.toggleInventoryLocationsChannel) {
        this.store.dispatch(new ToggleInventoryLocations(res.pin))
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          if (this.store.selectSnapshot(PharmacyState.inventoryLocationsEnabled)) {
            this.store.dispatch(new GetAllLocations());
          }
        })
      }
      else if (res?.success && res.dialogId === this.saveInventoryLocationsChannel) {
        this.saveLocation(res.pin);
      }
      
      if (res?.success) {
        this.pinService.closeDialog();
      }
    })

  }

  onEnableInventoryLocationsClick(): void {
    this.pinService.openPinDialog(this.toggleInventoryLocationsChannel);
  }

  addNew(): void {
    this.updateLocationData = null;
    this.displayAddEditLocationDialog$.next(true);
  }

  openSaveLocationPinDialog(data: {name: string, description?: string}): void {
    this.pinService?.openPinDialog(this.saveInventoryLocationsChannel);
    this.saveInventoryLocationData = data;
  }

  saveLocation(pin: number) : void {
    this.store
      .dispatch(
        new SaveInventoryLocation({
          id: this.updateLocationData?.id,
          pin,
          name: this.saveInventoryLocationData.name,
          description: this.saveInventoryLocationData.description,
        })
      )
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.displayAddEditLocationDialog$.next(false);
        this.updateLocationData = null;
      });
  }


  editLocation(rowData: IInventoryLocation) {
    this.updateLocationData = rowData;
    this.displayAddEditLocationDialog$.next(true);
  }


  tabWIChanged(tab: InventoryLocationStatusEnum): void {
    this.currentWITab = tab;
  }
}
